(() => {
  const categoryMenu = document.querySelector('[data-category-menu]');
  const categoryToggle = document.querySelector('[data-category-toggle]');
  const categoryPopover = document.querySelector('[data-category-popover]');
  const closeCategoryMenu = () => {
    if (!categoryToggle || !categoryPopover) return;
    categoryToggle.setAttribute('aria-expanded', 'false');
    categoryPopover.hidden = true;
  };
  if (categoryMenu && categoryToggle && categoryPopover) {
    categoryToggle.addEventListener('click', () => {
      const isOpen = categoryToggle.getAttribute('aria-expanded') === 'true';
      categoryToggle.setAttribute('aria-expanded', String(!isOpen));
      categoryPopover.hidden = isOpen;
    });
    document.addEventListener('click', event => {
      if (!categoryMenu.contains(event.target)) closeCategoryMenu();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeCategoryMenu();
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const mainImage = gallery.querySelector('[data-gallery-main-image]');
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        if (!mainImage || !thumb.dataset.imageUrl) return;
        mainImage.src = thumb.dataset.imageUrl;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.imageAlt || '';
        thumbs.forEach(item => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-product-purchase-form]').forEach(form => {
    const variantSelect = form.querySelector('select[name="id"]');
    const price = form.closest('.product-page__info')?.querySelector('[data-product-price]');
    if (!variantSelect || !price) return;
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      if (option?.dataset.variantPrice) price.textContent = option.dataset.variantPrice;
    });
  });

  document.querySelectorAll('[data-product-purchase-form]').forEach(form => {
    const toast = document.querySelector('[data-cart-toast]');
    let toastTimer;

    const showToast = message => {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3000);
    };

    form.addEventListener('submit', async event => {
      const submitter = event.submitter;
      if (!submitter) return;

      // Buy now keeps Shopify's native checkout flow.
      if (submitter.hasAttribute('data-buy-now')) {
        submitter.disabled = true;
        submitter.textContent = 'OPENING CHECKOUT…';
        return;
      }

      // Add to cart stays on the product page and shows a confirmation.
      if (!submitter.hasAttribute('data-add-to-cart')) return;
      event.preventDefault();

      const originalText = submitter.textContent;
      const status = form.querySelector('[data-product-submit-status]');
      submitter.disabled = true;
      submitter.textContent = 'ADDING…';
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this item.');

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
          headers: { 'Accept': 'application/json' }
        });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
        }

        showToast(`${result.product_title || 'Product'} has been added to your cart.`);
      } catch (error) {
        if (status) {
          status.hidden = false;
          status.textContent = error.message || 'Unable to add this item. Please try again.';
        }
      } finally {
        submitter.disabled = false;
        submitter.textContent = originalText;
      }
    });
  });


  // Cart quantities update automatically without requiring an Update Cart button.
  const cartForm = document.querySelector('.cart-form');
  if (cartForm) {
    const quantityInputs = [...cartForm.querySelectorAll('[data-cart-quantity]')];
    const subtotalEl = cartForm.querySelector('[data-cart-subtotal]');
    const shippingMessage = cartForm.querySelector('[data-free-shipping-message]');
    const statusEl = cartForm.querySelector('[data-cart-update-status]');
    const checkoutButton = cartForm.querySelector('.cart-checkout-button');
    let updateTimer;
    let activeController;

    const formatMoney = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format(cents / 100);
      } catch (_) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    const setUpdating = (isUpdating, message = '') => {
      quantityInputs.forEach(input => { input.disabled = isUpdating; });
      if (checkoutButton) checkoutButton.disabled = isUpdating;
      if (statusEl) statusEl.textContent = message;
      cartForm.classList.toggle('is-updating', isUpdating);
    };

    const renderCart = cart => {
      cart.items.forEach(item => {
        const line = cartForm.querySelector(`[data-cart-line][data-line-key="${CSS.escape(item.key)}"]`);
        if (!line) return;
        const lineTotal = line.querySelector('[data-cart-line-total]');
        const input = line.querySelector('[data-cart-quantity]');
        if (lineTotal) lineTotal.textContent = formatMoney(item.final_line_price, cart.currency);
        if (input) input.value = item.quantity;
      });

      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });

      if (shippingMessage) {
        const threshold = Number(shippingMessage.dataset.threshold || 5900);
        const detail = shippingMessage.querySelector('span:not(.cart-free-shipping__icon)');
        if (detail) {
          detail.textContent = cart.total_price < threshold
            ? `Add ${formatMoney(threshold - cart.total_price, cart.currency)} more to unlock free shipping.`
            : 'You’ve unlocked free shipping.';
        }
      }
    };

    const updateQuantity = async input => {
      const key = input.dataset.lineKey;
      const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
      activeController?.abort();
      activeController = new AbortController();
      setUpdating(true, 'Updating cart…');

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: key, quantity }),
          signal: activeController.signal
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || 'Unable to update your cart.');
        if (quantity === 0) {
          window.location.reload();
          return;
        }
        renderCart(cart);
        setUpdating(false, 'Cart updated.');
        window.setTimeout(() => { if (statusEl) statusEl.textContent = ''; }, 1800);
      } catch (error) {
        if (error.name === 'AbortError') return;
        setUpdating(false, error.message || 'Unable to update your cart.');
      }
    };

    quantityInputs.forEach(input => {
      const scheduleUpdate = () => {
        window.clearTimeout(updateTimer);
        updateTimer = window.setTimeout(() => updateQuantity(input), 450);
      };
      input.addEventListener('input', scheduleUpdate);
      input.addEventListener('change', scheduleUpdate);
    });
  }


  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const openButton = gallery.querySelector('[data-gallery-open]');
    const mainImage = gallery.querySelector('[data-gallery-main-image]');
    const lightbox = gallery.parentElement.querySelector('[data-product-lightbox]');
    if (!openButton || !mainImage || !lightbox) return;

    const lightboxImage = lightbox.querySelector('[data-lightbox-image]');
    const lightboxThumbs = [...lightbox.querySelectorAll('[data-lightbox-thumb]')];
    const closeButtons = [...lightbox.querySelectorAll('[data-lightbox-close]')];
    const prevButton = lightbox.querySelector('[data-lightbox-prev]');
    const nextButton = lightbox.querySelector('[data-lightbox-next]');
    let currentIndex = 0;
    let lastFocused = null;

    const setImage = (index) => {
      if (!lightboxImage) return;
      if (lightboxThumbs.length) {
        currentIndex = (index + lightboxThumbs.length) % lightboxThumbs.length;
        const thumb = lightboxThumbs[currentIndex];
        lightboxImage.classList.remove('is-ready');
        lightboxImage.src = thumb.dataset.imageUrl;
        lightboxImage.alt = thumb.dataset.imageAlt || '';
        lightboxThumbs.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === currentIndex));
      }
      const reveal = () => lightboxImage.classList.add('is-ready');
      if (lightboxImage.complete) requestAnimationFrame(reveal);
      else lightboxImage.addEventListener('load', reveal, { once: true });
    };

    const openLightbox = () => {
      lastFocused = document.activeElement;
      const activeMainThumb = [...gallery.querySelectorAll('[data-gallery-thumb]')].findIndex(item => item.classList.contains('is-active'));
      currentIndex = activeMainThumb >= 0 ? activeMainThumb : 0;
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('product-lightbox-open');
      setImage(currentIndex);
      requestAnimationFrame(() => lightbox.querySelector('.product-lightbox__close')?.focus());
    };

    const closeLightbox = () => {
      lightbox.classList.add('is-closing');
      window.setTimeout(() => {
        lightbox.hidden = true;
        lightbox.classList.remove('is-closing');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('product-lightbox-open');
        lastFocused?.focus();
      }, 190);
    };

    openButton.addEventListener('click', openLightbox);
    closeButtons.forEach(button => button.addEventListener('click', closeLightbox));
    lightboxThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => setImage(index)));
    prevButton?.addEventListener('click', () => setImage(currentIndex - 1));
    nextButton?.addEventListener('click', () => setImage(currentIndex + 1));

    lightbox.addEventListener('keydown', event => {
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') setImage(currentIndex - 1);
      if (event.key === 'ArrowRight') setImage(currentIndex + 1);
    });
  });
})();
